export enum FieldOfUse {

    INTERIOR = 'INTERIOR',
    EXTERIOR = 'EXTERIOR',
}